{
  "base": {
    "title": "Algo salió mal",
    "subtitle": "Gracias por su paciencia mientras trabajamos en la solución.",
    "redirectLabel": "Ir a la página de inicio",
    "helpCenterLink": "Visita el Centro de ayuda"
  }
}
